function readBooleanDebugFlag(key: string, fallback = false): boolean {
  try {
    const value = localStorage.getItem(key);
    if (value === null) return fallback;
    return value === '1' || value === 'true' || value === 'yes';
  } catch {
    return fallback;
  }
}

const PROJECT_REMOVE_DEBUG_ENABLED = readBooleanDebugFlag('webcoding-debug-project-remove');
const MAX_PROJECT_REMOVE_DEBUG_LINES = 80;

let panel: HTMLDivElement | null = null;
let body: HTMLDivElement | null = null;
let collapsed = true;
const lines: string[] = [];

function copyDebugText(text: string): boolean {
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}

function renderPanel(): void {
  if (!panel || !body) return;
  body.innerHTML = '';
  for (const line of lines) {
    const row = document.createElement('div');
    row.textContent = line;
    body.appendChild(row);
  }
  panel.style.width = collapsed ? '18px' : '';
  panel.style.height = collapsed ? '18px' : '';
  panel.style.minHeight = collapsed ? '18px' : '';
  panel.style.padding = collapsed ? '0' : '8px';
  panel.style.overflow = collapsed ? 'hidden' : 'auto';
  body.style.display = collapsed ? 'none' : 'block';
}

function ensurePanel(): void {
  if (panel || typeof document === 'undefined') return;
  panel = document.createElement('div');
  panel.id = 'project-remove-debug-panel';
  panel.style.position = 'fixed';
  panel.style.left = '56px';
  panel.style.right = '8px';
  panel.style.bottom = '34px';
  panel.style.zIndex = '99997';
  panel.style.maxHeight = '36vh';
  panel.style.overflow = 'auto';
  panel.style.padding = '8px';
  panel.style.background = 'rgba(24, 24, 27, 0.94)';
  panel.style.color = '#fef3c7';
  panel.style.border = '1px solid rgba(251, 191, 36, 0.5)';
  panel.style.borderRadius = '10px';
  panel.style.font = '12px/1.4 ui-monospace, SFMono-Regular, Menlo, monospace';
  panel.style.whiteSpace = 'pre-wrap';
  panel.style.wordBreak = 'break-word';

  const header = document.createElement('div');
  header.style.position = 'sticky';
  header.style.top = '0';
  header.style.display = 'flex';
  header.style.alignItems = 'center';
  header.style.gap = '6px';
  header.style.background = 'rgba(24,24,27,0.98)';
  header.style.padding = '0 0 6px 0';
  header.style.marginBottom = '6px';
  header.style.borderBottom = '1px solid rgba(251,191,36,0.3)';

  const title = document.createElement('div');
  title.textContent = 'project-remove-debug';
  title.style.flex = '1';

  const copyBtn = document.createElement('button');
  copyBtn.type = 'button';
  copyBtn.textContent = '复制';
  copyBtn.style.border = '1px solid rgba(251,191,36,0.5)';
  copyBtn.style.background = 'rgba(39,39,42,0.95)';
  copyBtn.style.color = '#fef3c7';
  copyBtn.style.borderRadius = '6px';
  copyBtn.style.padding = '2px 6px';
  copyBtn.style.font = 'inherit';
  copyBtn.addEventListener('click', () => {
    const text = lines.join('\n');
    const done = navigator.clipboard && typeof navigator.clipboard.writeText === 'function'
      ? navigator.clipboard.writeText(text).then(() => true).catch(() => copyDebugText(text))
      : Promise.resolve(copyDebugText(text));
    done.then((ok) => {
      copyBtn.textContent = ok ? '已复制' : '失败';
      window.setTimeout(() => { copyBtn.textContent = '复制'; }, 1200);
    });
  });

  const collapseBtn = document.createElement('button');
  collapseBtn.type = 'button';
  collapseBtn.textContent = '•';
  collapseBtn.title = '收起/展开';
  collapseBtn.style.border = '1px solid rgba(251,191,36,0.5)';
  collapseBtn.style.background = 'rgba(39,39,42,0.95)';
  collapseBtn.style.color = '#fef3c7';
  collapseBtn.style.borderRadius = '999px';
  collapseBtn.style.width = '18px';
  collapseBtn.style.height = '18px';
  collapseBtn.style.padding = '0';
  collapseBtn.style.lineHeight = '1';
  collapseBtn.style.font = 'inherit';
  collapseBtn.addEventListener('click', () => {
    collapsed = !collapsed;
    collapseBtn.textContent = collapsed ? '•' : '–';
    copyBtn.style.display = collapsed ? 'none' : '';
    title.style.display = collapsed ? 'none' : '';
    header.style.marginBottom = collapsed ? '0' : '6px';
    header.style.paddingBottom = collapsed ? '0' : '6px';
    header.style.borderBottom = collapsed ? 'none' : '1px solid rgba(251,191,36,0.3)';
    renderPanel();
  });

  header.appendChild(title);
  header.appendChild(copyBtn);
  header.appendChild(collapseBtn);
  panel.appendChild(header);
  body = document.createElement('div');
  panel.appendChild(body);
  document.body.appendChild(panel);
  renderPanel();
}

export function logProjectRemoveDebug(event: string, payload: any = {}): void {
  if (!PROJECT_REMOVE_DEBUG_ENABLED) return;
  const line = `[project-remove] ${new Date().toISOString()} ${event} ${JSON.stringify(payload)}`;
  console.info(line);
  ensurePanel();
  lines.push(line);
  while (lines.length > MAX_PROJECT_REMOVE_DEBUG_LINES) lines.shift();
  renderPanel();
  if (panel && !collapsed) panel.scrollTop = panel.scrollHeight;
}
